module.exports = {
    "baseUrl": "https://api-v4.iris-health.com",
    "systemName": "System Prod",
    "stripeKey": "pk_live_51Ia02yIg43ZjHHGkZRwf5Ap3qTBlvEKJIe08edJWqyVDlEs30E8wHlnWl8XWqfzlEufmqMwattqTzzojGlDc6Sul00stDc8rJm",
    "companyTitle": "Iris Check in",
    "metaTitle": "Iris Health Scheduler Web App",
    "metaDescription": "Scheduler for physicians and clinics from Iris Health",
    "favicon": "%PUBLIC_URL%/iris/iconWhite.ico",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris",
    "redirectUrl": "https://www.iris-health.com/",
    "cdnUrl": "https://cdn.iris-health.com"
}